import {createSelector} from 'reselect';
import get from 'lodash/get';
import find from 'lodash/find';
import {emptyPageFactory} from './factories';
import * as ResourceApi from "../api/resources";

// NOTE: These selectors (including those created by the selector factories below) accept
//       the `resources` slice of the store so that they can be used anywhere, i.e. in
//       both reducers and mapStateToProps.

export const resourcePagesSelector = resources => resources.resourcePages;
export const allResourcesSelector = resources => resources.allResources;
export const resourcesSelector = resources => resources.resources;

export const createResourceTypeSelector = resourceType => createSelector(
    resourcesSelector,
    (resources) => Object.keys(resources)
        .filter(id => {
            // So this filter doesn't kill app on malformed data
            // Cause still unknown
            if (!resources[id].resourceId) {
                console.error("no resourceId for resource", resources[id]);
                return false;
            }
            return resources[id].resourceId.type === resourceType;
        })
        .map(id => resources[id])
);

export const createResourcePageSelector = resourceType => createSelector(
  resourcePagesSelector,
  resourcePages => resourcePages[resourceType] || emptyPageFactory()
);

export const createAllResourceItemsSelector = resourceType => createSelector(
  resourcesSelector,
  allResourcesSelector,
  (resources, allResources) => (allResources[resourceType] ? allResources[resourceType].content : []).map(id => resources[id])
);

export const createResourcePageItemsSelector = resourceType => createSelector(
  resourcesSelector,
  createResourcePageSelector(resourceType),
  (resources, resourcePage) => (
    (resourcePage.content || [])
      .map(id => resources[id])
      .filter(Boolean)
  )
);

export const createResourceSelector = id => createSelector(
  resourcesSelector,
  resources => resources[id] || null
);

// for accessing a resource that is nested inside another one; `path` denotes the
// property path to check in the parent resource for the nested one.
export const createNestedResourceSelector = (path, id) => createSelector(
  resourcesSelector,
  resources => {
    const matchNestedById = resource => {
      const nested = get(resource, path);
      return get(nested, 'id', null) === id;
    };

    const parent = find(resources, matchNestedById);
    return get(parent, path, null);
  }
);

export const createAutoSaveStatusSelector = key => createSelector(
  resources => resources,
  resources => ({
    isSaving: Boolean(resources.pendingSaves[key]),
    error: Boolean(resources.saveErrors[key]),
    saved: Boolean(resources.savedField[key])
  })
);

export const getGroups = createResourceTypeSelector(ResourceApi.Types.Group);


// WEBPACK FOOTER //
// ./public/resources/selectors.js